import { Badge } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

interface MarketplaceRoleBadgeProps {
  status: string;
  preAuth?: boolean;
}

const MarketplaceRoleBadge = ({ status, preAuth }: MarketplaceRoleBadgeProps) => {
  const [statusColor, setStatusColor] = useState('gray');
  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    switch (status) {
      case 'active':
        setStatusColor('green');
        setStatusMessage('Active');
        break;
      case 'pending':
        setStatusColor('yellow');
        setStatusMessage('Pending');
        break;
      case 'inactive':
        setStatusColor('red');
        setStatusMessage('Inactive');
        break;
      case 'pending_payment':
        setStatusColor('yellow');
        const pendingMessage = preAuth ? 'Pending Authorization' : 'Pending Payment';
        setStatusMessage(pendingMessage);
        break;
    }
  }, []);

  return <Badge colorScheme={statusColor}>{statusMessage}</Badge>;
};

export default MarketplaceRoleBadge;
